<template>
  <div id="scroll">
    <div class="container">
      <div class="editWrap">
        <editor-vue
          class="editor"
          :value="ruleForm.text"
          @input="(res) => (ruleForm.text = res)"
        >
        </editor-vue>
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="addNew()">确 定</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { addSysTrain ,editSysTrain} from "@/api/manage";
import editorVue from "@/components/txtModule/richText.vue";
export default {
  data() {
    return {
      ruleForm: {
        text: "",
      },
      val: "",
      isEdit: false,
      editId: "",
    };
  },
  components: {
    editorVue,
  },
  created() {
    this.isEdit = this.$route.params.typeOf == "edit";
    this.editId = this.$route.params.id||'';
    this.editId = this.$route.params.id||'';
    this.ruleForm.text=this.$route.params.text?decodeURI(this.$route.params.text):''
  },
  methods: {
    async addNew() {
      //确认新增
        if (!this.isEdit) {  //新增
          if ( this.ruleForm.text.length !== 0) {
            //必填项不能为空，否则不能上传
            this.ruleForm.text=encodeURI(this.ruleForm.text+'')
            let res = await addSysTrain(this.ruleForm);
            if (res.code == 200) {
                this.$message.success("新增培训发展成功！");
              this.ruleForm.text=''
              this.$router.replace("/talents");
            }
          } else {
            return false;
          }
        } else {//编辑状态
          let param = {};
          param.id = this.editId
          param.text = encodeURI(this.ruleForm.text+'')
          let res = await editSysTrain(param);
          if(res.code==200){
            this.$message.success('编辑成功！')
            this.$router.replace("/talents");
          }
        }
    },
    cancel() {
      console.log("取消");
    },
  },
};
</script>

<style lang="less" scoped>
#scroll {
  height: 100%;
}
.container {
  padding: 30px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 5px;
}
.el-form {
  display: flex;
  flex-wrap: wrap;
}
.el-form .el-input {
  width: 215px;
}
</style>